import { textSendAttemptScope } from "./textSendAttempts.mjs";

// Projection only: never write a provisional bubble to Firebase or pretend
// that transport acceptance proves WhatsApp delivery. Match solely by ID.
export function mergeTextSendMessages(messages, attempts, storeId, phone) {
  const scope = textSendAttemptScope(storeId, phone);
  const local = attempts.filter(r => r.scope === scope);
  const byId = new Map(local.map(r => [r.id, r]));
  const seen = new Set();
  const result = messages.map(m => {
    const id = m.crmMessageId || m.clientMsgId || m.id;
    const attempt = byId.get(id);
    if (!attempt) return m;
    seen.add(id);
    // Durable server state wins over an uncertain/lost POST response.
    const proven = ["sent", "sending", "retry"].includes(m.status) || Number(m.waAck) > 0;
    return { ...m, _textOrderAt:attempt.createdAt, _textAttempt:proven || attempt.phase === "accepted" ? null : attempt };
  });
  for (const r of local) {
    if (seen.has(r.id)) continue;
    result.push({
      id:r.id, crmMessageId:r.id, storeId:r.storeId, remetente:"consultor",
      texto:r.draft.trim(), timestamp:new Date(r.createdAt).toISOString(),
      status:r.phase === "accepted" ? "pending" : r.phase === "failed" ? "failed" : "pending",
      quotedMsg:r.quote, _textAttempt:r, _localTextAttempt:true, _textOrderAt:r.createdAt,
    });
  }
  const time = m => m._textOrderAt ?? (typeof m.timestamp === "number" || /^\d{10,}$/.test(m.timestamp || "")
    ? Number(m.timestamp) : Date.parse(m.timestamp || "") || 0);
  return result.sort((a,b) => time(a) - time(b));
}
